import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
import './locales'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { Spinner } from 'components/ui'
import { dateLocales, updateTranslations } from 'locales'
import { getLanguage, getTranslation } from 'services/LanguageService'
import dayjs from 'dayjs'
import i18n from 'i18next'

function App() {
    const [bootLoading, setBootLoading] = useState(true)

    useEffect(() => {
        const loadDefaultI18n = async () => {
            try {
                // Fetch languages and find default TR
                const response = await getLanguage()
                const list = response?.data?.data || []
                const trLanguage = list.find(
                    (lang) => lang.isActive && String(lang.code || '').toLowerCase().startsWith('tr')
                )
                if (trLanguage) {
                    // Load translations for TR
                    const trans = await getTranslation({ code: trLanguage.code })
                    const items = trans?.data?.data || []
                    if (Array.isArray(items) && items.length) {
                        await updateTranslations('tr', items)
                    }
                    // Setup dayjs locale
                    try {
                        if (dateLocales['tr']) {
                            await dateLocales['tr']()
                            dayjs.locale('tr')
                        }
                    } catch {}
                    // Set i18n language
                    i18n.changeLanguage('tr')
                }
            } catch (e) {
                // Swallow errors and continue
            } finally {
                setBootLoading(false)
            }
        }
        loadDefaultI18n()
    }, [])

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter history={history}>
                    <GoogleOAuthProvider clientId={"603599973081-55eu7b6fl0t6k258i2mpietdgvbb2jmc.apps.googleusercontent.com"}>
                        {bootLoading ? (
                            <div className="flex h-screen w-full justify-center items-center flex-col">
                                <Spinner size="3.25rem" />
                            </div>
                        ) : (
                            <Theme>
                                <Layout />
                            </Theme>
                        )}
                    </GoogleOAuthProvider>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
